var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboard = function SvgKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#keyboard_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 17.778,
    y: 0.109,
    fill: "#7D898D",
    rx: 2.667
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 2,
    y: 2.336,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 7.777,
    y: 2.336,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 13.555,
    y: 2.336,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 19.332,
    y: 2.336,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 25.109,
    y: 2.336,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 4.891,
    y: 7.578,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 10.668,
    y: 7.578,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 16.445,
    y: 7.578,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.889,
    height: 3.111,
    x: 22.223,
    y: 7.578,
    fill: "#ADB4B6",
    rx: 1.556
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.128,
    height: 2.844,
    x: 6.938,
    y: 12.828,
    fill: "#ADB4B6",
    rx: 1.422
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "keyboard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .11h32v17.777H0z"
  })))));
};
export default SvgKeyboard;